import { z } from 'zod/v4';

export const userinfoSchema = z.object({
  account_id: z.string().optional(),
  country: z.string().optional(),
  data_region: z.string(),
  email: z.string(),
  email_verified: z.boolean(),
  family_name: z.string(),
  given_name: z.string(),
  identity_type: z.string(),
  locale: z.string(),
  picture: z.string(),
});

export type Userinfo = z.infer<typeof userinfoSchema>;
